/**
 * Imports the necessary React components and libraries for a specific module.
 * @module
 * @requires React
 * @requires Card from "react-bootstrap"
 * @requires Tab from "react-bootstrap/Tab"
 * @requires Tabs from "react-bootstrap/Tabs"
 * @requires useTranslation from "react-i18next"
 * @requires CSmartTable from "@coreui/react-pro"
 * @requires CustomToggleButton from "../../../components/customToggleButton/customToggleButton"
 * @requires Breadcrumbs from "../../../components/customBreadcrumb/customBreadcrumb"
 * @requires ConfirmModal from "../../../components/confirmModal/confirmModel"
 * @requires EmptyCell from "../../../components/emptyCell/emptyCell"
 * @requires CustomLoadingHTML from "../../../components/customLoadingHTML/customLoadingHTML
 */
import React, { useEffect, useState } from "react";
import moment from "moment";
import { Card } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useTranslation } from "react-i18next";
import { CSmartTable } from "@coreui/react-pro";

import EmptyCell from "../../../components/emptyCell/emptyCell";
import ConfirmModal from "../../../components/confirmModal/confirmModel";
import CustomeShimer from "../../../components/customeShimer/customeShimer";
import Breadcrumbs from "../../../components/customBreadcrumb/customBreadcrumb";
import CustomLoadingHTML from "../../../components/customLoadingHTML/customLoadingHTML";
import CustomToggleButton from "../../../components/customToggleButton/customToggleButton";

import { getCloudinaryMediaBaseUrl } from "../../../config/cloudinaryBase";
import Constant from "../../../util/constant";

const OrganiserDetailsComponent = (props) => {
  const { t } = useTranslation();

  /**
   * Constructs the Cloudinary URL by concatenating the environment variables
   * for the Cloudinary URL, name, and subfolder.
   * @returns The constructed Cloudinary URL.
   */
  const CLOUDINARY_URL = getCloudinaryMediaBaseUrl();
  /**
   * Destructures the props object and assigns the corresponding values to variables.
   * @param {{object}} props - The props object containing various properties.
   * @returns None
   */
  const {
    loading,
    smarttableref,

    itemsPerPage,
    placeHolderShimer,
    noDataFound,
    dimensions,
    noDataTitle,
    noDataAddButtonTitle,
    noDataDesc,
    emptyDataAddButton,
    clearSearchButton,
    breadcrumbHeight,

    tabHeaderHeight,
    loaderHtml,
    tableContainerRef,
    userContentHeight,
    tabHeight,
    showDeleteUserModal,
    onDeleteUser,
    closeDeleteUserModal,
    openDeleteUserModal,
    onCheckAction,
    onHide,
    showStatusModal,
    onProcced,
    closeDeactiveModal,
    isCheckSwitch,

    pageTitle,

    showViewTicketModal,
    onViewTicket,
    closeViewTicketModal,
    backPageFunction,
    organiser,
    currentEventColumns,
    pastEventColumns,
    pastEventsOfOrganiser,
    currentEventsOfOrganiser,
  } = props;

  if (tableContainerRef.current) {
    const emptyRows =
      tableContainerRef.current.getElementsByClassName("emptyRow");
    if (emptyRows) {
    }
  }

  const [screenWidth, setScreenWidth] = useState(window.screen.width);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.screen.width]);
  /**
   * Renders a React component that displays the details of a user.
   * @returns {JSX.Element} - The rendered React component.
   */
  return (
    <>
      <React.Fragment>
        <div className="pageContent organiserDetails">
          {/**
           * Renders a Breadcrumbs component with the specified props
           * @param {{boolean}} breadcrumbMainTitle - Determines whether to display the main title in the breadcrumbs.
           * @param {{boolean}} breadcrumbInner - Determines whether to display the inner breadcrumbs.
           * @param {{string}} innerPagetitle - The title of the inner page.
           * @param {{Function}} backPageFunction - The function to be called when the back button is clicked.
           * @returns The rendered Breadcrumbs component.
           */}
          <Breadcrumbs
            pageTitle={pageTitle}
            BreadcrumbInner={true}
            innerPagetitle={organiser?.fullname}
            BreadcrumbmainTitle={true}
            breadcrumbItem={organiser?.fullname}
            backArrow={true}
            onBackArrow={backPageFunction}
          />
          {/**
           * Renders a card component with various details and buttons.
           * @returns The rendered card component.
           */}
          <Card className="userContaint">
            <Card.Body className="p-0">
              <div className="mainDetailsWrapper">
                <div className="documentImage">
                  {placeHolderShimer && <CustomeShimer />}
                  <img src={CLOUDINARY_URL + "user.png"} alt="PDF_150x150" />
                </div>
                <div className="documentContent">
                  <div className="userType_Wrapper">
                    <div className="labelNameStyle">{t("USERNAME")}</div>
                    <span className="textNameStyle">
                      {placeHolderShimer && <CustomeShimer />}
                      {organiser?.fullname}
                    </span>
                  </div>
                  <div className="userType_Wrapper">
                    <div className="labelNameStyle">
                      {t("EMAIL_ADDRESS")}
                    </div>
                    <span className="textNameStyle">
                      {placeHolderShimer && <CustomeShimer />}
                      {organiser?.email}
                    </span>
                  </div>
                  <div className="userType_Wrapper">
                    <div className="labelNameStyle">
                      {t("PHONE_NUMBER")}
                    </div>
                    <span className="textNameStyle">
                      {placeHolderShimer && <CustomeShimer />}
                      {organiser?.phone}
                    </span>
                  </div>
                  <div className="userType_Wrapper">
                    <div className="labelNameStyle">{t("JOINED_ON")}</div>
                    <span className="textNameStyle">
                      {placeHolderShimer && <CustomeShimer />}
                      {organiser?.joinedon
                        ? moment(organiser?.joinedon).utc().format("DD MMM YY")
                        : "-"}
                    </span>
                  </div>
                </div>
                <div className="detailsBtnWrapper">
                  <div className="status">
                    {placeHolderShimer && <CustomeShimer />}
                    <span>{t("STATUS")}</span>
                    <span className={isCheckSwitch ? "success" : "Deactivated"}>
                      {isCheckSwitch ? t("ACTIVE") : t("DEACTIVATED")}
                    </span>
                  </div>
                  <div className="documentEditWrapperButton">
                    {placeHolderShimer && <CustomeShimer />}
                    <CustomToggleButton
                      id=""
                      checked={isCheckSwitch}
                      onCheckChange={(e) => {
                        onCheckAction(e, organiser);
                      }}
                    />
                    <button
                      className="deleteButtton"
                      onClick={(e, item) => openDeleteUserModal(e, organiser)}
                    >
                      <i className="bx bxs-trash" id="deletetooltip"></i>
                    </button>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>

          {/**
           * Renders a Card component with multiple tabs and a table.
           * @returns The rendered Card component.
           */}
          <Card
            className={
              loading
                ? "mainCard Main_User_Management_Details LoadingTable"
                : "mainCard Main_User_Management_Details"
            }
          >
            <Card.Body className="p-0 activeTabSupplier">
              <div className="mainCardBody">
                <Tabs
                  defaultActiveKey="active_events"
                  id="uncontrolled-tab-example"
                  className="mb-3 user-details-tabs"
                >
                  <Tab eventKey="active_events" title={t("ACTIVE_EVENTS")}>
                    <CSmartTable
                      ref={smarttableref}
                      cleaner
                      clickableRows
                      columns={currentEventColumns}
                      columnFilter={false}
                      items={currentEventsOfOrganiser}
                      itemsPerPage={itemsPerPage}
                      scopedColumns={{
                        title: (item) => {
                          return (
                            <td>
                              <div className="eventDetail tdWrapper">
                                {placeHolderShimer && (
                                  <div className="shimer"></div>
                                )}
                                <img
                                  src={
                                    item.image === "" || undefined || null
                                      ? CLOUDINARY_URL + "dummy-profile.png"
                                      : CLOUDINARY_URL + item.image
                                  }
                                  alt=""
                                />
                                <div className="eventDetailsRow">
                                  <div className="titleStyle">{item.title}</div>
                                  <div className="locationStyle">
                                    {item.location}
                                  </div>
                                </div>
                              </div>
                              <div
                                className="eventDetailsRow1 resposiveViewStyle">
                                <div className="address tdWrapper">
                                  {placeHolderShimer && (
                                    <div className="shimer"></div>
                                  )}
                                  {moment(item.startdatetime)
                                    .utc()
                                    .format("DD MMM YY, h:mm A")}
                                  {t("TO")}
                                  {moment(item.enddatetime)
                                    .utc()
                                    .format("DD MMM YY, h:mm A")}
                                </div>
                                <div className="artistRepeat tdWrapper">
                                  {placeHolderShimer && (
                                    <div className="shimer"></div>
                                  )}
                                  {item.artist.map((item) => {
                                    return (
                                      <div className="artist">
                                        <img
                                          width={30}
                                          height={30}
                                          src={
                                            item.artistimage === "" ||
                                              undefined ||
                                              null
                                              ? CLOUDINARY_URL +
                                              "dummy-profile.png"
                                              : CLOUDINARY_URL + item.artistimage
                                          }
                                          alt=""
                                        />
                                        <p>{item?.artistname}</p>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </td>
                          );
                        },
                        eventTimings: (item, e) => {
                          return (
                            <td>
                              <div className="address tdWrapper">
                                {placeHolderShimer && (
                                  <div className="shimer"></div>
                                )}
                                {moment(item.startdatetime)
                                  .utc()
                                  .format("DD MMM YY, h:mm A")}
                                {t("TO")}
                                <br></br>
                                {moment(item.enddatetime)
                                  .utc()
                                  .format("DD MMM YY, h:mm A")}
                              </div>
                            </td>
                          );
                        },
                        artist: (item) => {
                          return (
                            <td>
                              <div className="artistRepeat tdWrapper">
                                {placeHolderShimer && (
                                  <div className="shimer"></div>
                                )}
                                {item.artist.map((item) => {
                                  return (
                                    <div className="artist">
                                      <img
                                        width={30}
                                        height={30}
                                        src={
                                          item.artistimage === "" ||
                                            undefined ||
                                            null
                                            ? CLOUDINARY_URL +
                                            "dummy-profile.png"
                                            : CLOUDINARY_URL + item.artistimage
                                        }
                                        alt=""
                                      />
                                      <p>{item?.artistname}</p>
                                    </div>
                                  );
                                })}
                              </div>
                            </td>
                          );
                        },
                        category: (item, e) => {
                          return (
                            <td>
                              <div className='category'>
                                {item.category.map((item) => {
                                  return (
                                    <>
                                      <div className="category tdWrapper">
                                        {placeHolderShimer && (
                                          <div className="shimer"></div>
                                        )}
                                        <p>{item?.title}</p>
                                      </div>
                                    </>
                                  );
                                })}
                              </div>
                            </td>
                          );
                        },


                        eventstatus: (item, e) => {
                          return (
                            <td>
                              <div
                                className={
                                  item.eventstatus === "Ongoing"
                                    ? "onGoing tdWrapper"
                                    : item.eventstatus === "Upcoming"
                                      ? "upComing tdWrapper"
                                      : item.eventstatus === "Cancel"
                                        ? "cancelled tdWrapper"
                                        : item.eventstatus === "Completed"
                                          ? "completed tdWrapper"
                                          : "tdWrapper"
                                }
                              >
                                {placeHolderShimer && (
                                  <div className="shimer"></div>
                                )}
                                {item.eventstatus}
                              </div>
                            </td>
                          );
                        },
                        ticketPrice: (item, e) => {
                          return (
                            <td>
                              <div>
                                <div className="address tdWrapper">
                                  {placeHolderShimer && (
                                    <div className="shimer"></div>
                                  )}
                                  {item.ticketPrice}
                                </div>
                                <div className='eventDetailsRow2 resposiveViewStyle'>
                                  <div className="ticketSoldStyle tdWrapper">
                                    {placeHolderShimer && (
                                      <div className="shimer"></div>
                                    )}
                                    <span>
                                      {" "}
                                      {item?.ticketssold}
                                      {""} / {""}
                                    </span>
                                    <span className="tcketTotal">
                                      {item?.totaltickets}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </td>
                          );
                        },
                        ticketssold: (item, e) => {
                          return (
                            <td>
                              <div className="tdWrapper">
                                {placeHolderShimer && (
                                  <div className="shimer"></div>
                                )}
                                <span>
                                  {" "}
                                  {item?.ticketssold}
                                  {""} / {""}
                                </span>
                                <span className="tcketTotal">
                                  {item?.totaltickets}
                                </span>
                              </div>

                            </td>
                          );
                        },

                      }}
                      tableFilterPlaceholder={t("serach user")}
                      tableProps={{
                        className: "userMangmentTable",
                        responsive: true,
                        striped: false,
                        hover: false,
                      }}
                      noItemsLabel={
                        <EmptyCell
                          emptyItems={currentEventsOfOrganiser}
                          emptyImg={Constant.NODATAIMAGE_URL.EVENTS}
                          emptyTitle={t("NO_ACTIVE_EVENTS_YET")}
                          emptyDataDesc={t(
                            "NO_EVENT_HAS_BEEN_ACTIVE_PLEASE_CHECK_AFTER_SOMETIME"
                          )}
                          noDataTitle={
                            // currentEventsOfOrganiser.length ===
                            0 ? noDataFound : noDataTitle
                          }
                          noDataAddButton={false}
                          noDataAddButtonTitle={noDataAddButtonTitle}
                          noDataDesc={noDataDesc}
                          emptyDataAddButton={emptyDataAddButton}
                          clearSearchButton={clearSearchButton}
                        />
                      }
                      tableBodyProps={{
                        className: "align-middle Table-Body-scroll",
                        style: {
                          height:
                            dimensions.height -
                            breadcrumbHeight -
                            userContentHeight -
                            tabHeaderHeight -
                            tabHeight -
                            (loading && loaderHtml) -
                            110,
                        },
                        ref: tableContainerRef,
                      }}
                    />
                    {loading && <CustomLoadingHTML />}
                  </Tab>
                  <Tab eventKey="past_events" title={t("PAST_EVENTS")}>
                    <CSmartTable
                      ref={smarttableref}
                      cleaner
                      clickableRows
                      columns={pastEventColumns}
                      columnFilter={false}
                      items={pastEventsOfOrganiser}
                      itemsPerPage={itemsPerPage}
                      scopedColumns={{
                        title: (item) => {
                          return (
                            <td>
                              <div className="eventDetail tdWrapper">
                                {placeHolderShimer && (
                                  <div className="shimer"></div>
                                )}
                                <img
                                  src={
                                    item.image === "" || undefined || null
                                      ? CLOUDINARY_URL + "dummy-profile.png"
                                      : CLOUDINARY_URL + item.image
                                  }
                                  alt=""
                                />
                                <div className="eventDetailsRow">
                                  <div className="titleStyle">{item.title}</div>
                                  <div className="locationStyle">
                                    {item.location}
                                  </div>
                                </div>
                              </div>

                              <div className="documentContent">
                                <div
                                  className={
                                    screenWidth > 1440
                                      ? "eventDetailsRow1"
                                      : "eventDetailsRow2"
                                  }
                                >
                                  {screenWidth > 1440 ? null : (
                                    <>
                                      <div className="address1">
                                        {placeHolderShimer && (
                                          <div className="shimer"></div>
                                        )}
                                        {moment(item.startdatetime)
                                          .utc()
                                          .format("DD MMM YY, h:mm A")}
                                        {t("TO")}
                                        {moment(item.enddatetime)
                                          .utc()
                                          .format("DD MMM YY, h:mm A")}
                                      </div>

                                      <div className="address1">
                                        {placeHolderShimer && (
                                          <div className="shimer"></div>
                                        )}
                                        {item.ticketPrice}
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            </td>
                          );
                        },

                        artist: (itemA) => {
                          return (
                            <td>
                              <div className="artistRepeat tdWrapper">
                                {placeHolderShimer && (
                                  <div className="shimer"></div>
                                )}
                                {itemA.artist.map((item) => {
                                  return (
                                    <div className="artist">
                                      <img
                                        width={30}
                                        height={30}
                                        src={
                                          item.artistimage === "" ||
                                            undefined ||
                                            null
                                            ? CLOUDINARY_URL +
                                            "dummy-profile.png"
                                            : CLOUDINARY_URL + item.artistimage
                                        }
                                        alt=""
                                      />
                                      <p>{item?.artistname}</p>
                                    </div>
                                  );
                                })}
                              </div>
                            </td>
                          );
                        },
                        category: (item, e) => {
                          return (
                            <td>
                              {item?.category?.map((item) => {
                                return (
                                  <>
                                    <div className="category tdWrapper">
                                      {placeHolderShimer && (
                                        <div className="shimer"></div>
                                      )}
                                      <p>{item?.title}</p>
                                    </div>
                                  </>
                                );
                              })}
                            </td>
                          );
                        },
                        eventTimings: (item, e) => {
                          return (
                            <>
                              {screenWidth > 1440 ? (
                                <td>
                                  <div className="address tdWrapper">
                                    {placeHolderShimer && (
                                      <div className="shimer"></div>
                                    )}
                                    {moment(item.startdatetime)
                                      .utc()
                                      .format("DD MMM YY, h:mm A")}
                                    {t("TO")}
                                    {moment(item.enddatetime)
                                      .utc()
                                      .format("DD MMM YY, h:mm A")}
                                  </div>
                                </td>
                              ) : null}{" "}
                              {/* Return null when screenWidth is not greater than 1440 */}
                            </>
                          );
                        },
                        eventstatus: (item, e) => {
                          return (
                            <td>
                              <div
                                className={
                                  item.eventstatus === "Ongoing"
                                    ? "onGoing tdWrapper"
                                    : item.eventstatus === "Upcoming"
                                      ? "upComing tdWrapper"
                                      : item.eventstatus === "Cancel"
                                        ? "cancelled tdWrapper"
                                        : item.eventstatus === "Completed"
                                          ? "completed tdWrapper"
                                          : "tdWrapper"
                                }
                              >
                                {placeHolderShimer && (
                                  <div className="shimer"></div>
                                )}
                                {item.eventstatus}
                              </div>
                            </td>
                          );
                        },
                        ticketssold: (item, e) => {
                          return (
                            <td>
                              <div className="tdWrapper">
                                {placeHolderShimer && (
                                  <div className="shimer"></div>
                                )}

                                <span>
                                  {" "}
                                  {item?.ticketssold}
                                  {""} / {""}
                                </span>
                                <span className="tcketTotal">
                                  {item?.totaltickets}
                                </span>
                              </div>
                            </td>
                          );
                        },
                        ticketPrice: (item, e) => {
                          return (
                            <>
                              {screenWidth > 1440 ? (
                                <td>
                                  <div className="address tdWrapper">
                                    {placeHolderShimer && (
                                      <div className="shimer"></div>
                                    )}
                                    {item.ticketPrice}
                                  </div>
                                </td>
                              ) : null}{" "}
                              {/* Return null when screenWidth is not greater than 1440 */}
                            </>
                          );
                        },
                      }}
                      tableFilterPlaceholder={t("serach user")}
                      tableProps={{
                        className: "userMangmentTable",
                        responsive: true,
                        striped: false,
                        hover: false,
                      }}
                      noItemsLabel={
                        <EmptyCell
                          emptyItems={pastEventsOfOrganiser}
                          emptyImg={Constant.NODATAIMAGE_URL.EVENTS}
                          emptyTitle={t("NO_PAST_EVENTS_YET")}
                          emptyDataDesc={t(
                            "NO_EVENT_HAS_BEEN_COMPLETED_PLEASE_CHECK_AFTER_SOMETIME"
                          )}
                          noDataTitle={
                            pastEventsOfOrganiser.length === 0
                              ? noDataFound
                              : noDataTitle
                          }
                          noDataAddButton={false}
                          noDataAddButtonTitle={noDataAddButtonTitle}
                          noDataDesc={noDataDesc}
                          emptyDataAddButton={emptyDataAddButton}
                          clearSearchButton={clearSearchButton}
                        />
                      }
                      tableBodyProps={{
                        className: "align-middle Table-Body-scroll",
                        style: {
                          height:
                            dimensions.height -
                            breadcrumbHeight -
                            userContentHeight -
                            tabHeaderHeight -
                            tabHeight -
                            (loading && loaderHtml) -
                            110,
                        },
                        ref: tableContainerRef,
                      }}
                    />
                    {loading && <CustomLoadingHTML />}
                  </Tab>
                </Tabs>
              </div>
            </Card.Body>
          </Card>
        </div>
      </React.Fragment >

      {/** * Renders a confirmation modal for deleting a user. * @param{" "}
      {{ string }} modalTitle - The title of the modal. * @param {{ string }}{" "}
      modalDescription - The description of the modal. * @param {{ boolean }}{" "}
      isUnderline - Determines if the modal title should be underlined. * @param{" "}
      {{ boolean }} showModal - Determines if the modal should be shown. *
      @param {{ string }} leftBtnTitle - The title of the left button. * @param{" "}
      {{ boolean }} isModelIcon - Determines if an icon should be displayed in
      the modal. * @param {{ string }} iconColor - The color of the icon. *
      @param {{ string }} iconCricle - The class name for the icon circle. * @
      */}
      < ConfirmModal
        modalTitle={t("DELETE")}
        modalDescription={t("ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ORGANISER")}
        isUnderline={false}
        showModal={showDeleteUserModal}
        leftBtnTitle={t("YES_DELETE")}
        isModelIcon={true}
        iconColor={"mdi mdi-delete-outline "}
        iconCricle={"iconCricleDelete"}
        leftBtnClass={"ok_Btn"}
        isFirstButton={true}
        isSecondButton={true}
        rightBtnClass="borderButton"
        rightBtnTitle={t("NO_CANCEL")}
        onProcced={onDeleteUser}
        rightButtonClick={closeDeleteUserModal}
      />
      {/**
       * Renders a confirmation modal component for deactivating a category.
       * @param {{string}} className - The CSS class name for the modal.
       * @param {{boolean}} isModelIcon - Determines if an icon should be displayed in the modal.
       * @param {{function}} onHide - Callback function to handle hiding the modal.
       * @param {{string}} iconColor - The color of the icon in the modal.
       * @param {{string}} iconCricle - The CSS class name for the circle icon in the modal.
       * @param {{string}} modalTitle - The title of the modal.
       * @param {{string}} modalDescription - The description text of the modal.
       * @param {{boolean}} isUnderline - Determines if
       */}
      < ConfirmModal
        className={"Deactivate"}
        isModelIcon={true}
        onHide={onHide}
        iconColor={"mdi mdi-toggle-switch-off-outline "}
        iconCricle={"iconCricleDelete"}
        modalTitle={t("DEACTIVATE")}
        modalDescription={
          t(
            "ARE_YOU_SURE_YOU_WANT_TO_DEACTIVATE_THIS_ORGANISER"
          )
        }
        isUnderline={false}
        showModal={showStatusModal}
        leftBtnTitle={t("YES_DEACTIVATE")}
        isFirstButton={true}
        leftBtnClass={"Deactivate-btn"}
        onProcced={(e, item) => {
          onProcced(e, item);
        }}
        rightBtnClass="Cancel_Btn"
        isSecondButton={true}
        rightBtnTitle={t("NO_CANCEL")}
        rightButtonClick={closeDeactiveModal}
      />

      <ConfirmModal
        className="viewTicketModal userViewTicketModal"
        isModelIcon={false}
        isCloseBtn={true}
        closeModelIcon={() => closeViewTicketModal()}
        isUnderline={false}
        showModal={showViewTicketModal}
        isFirstButton={false}
        isSecondButton={false}
        onProcced={onViewTicket}
        rightButtonClick={closeViewTicketModal}
        modalContent={false}
        badgeDate={true}
        modalTitleDiv={false}
        status={"Amount Paid"}
        date={"on 04 Oct 23, 09:23 PM"}
      >
        <div className="viewTicketBody">
          <div className="bodyUpper">
            <span className="ticketTitle">The Weekend</span>
            <span className="ticketId">
              {t("TICKETID")}: ABCDE-0011AA-00223F
            </span>
            <span className="ticketTime">
              {t("EVENT_TIMINGS")}: 07 Oct 23, 10:00 AM
            </span>
            <span className="ticketBarcode">
              <img src={CLOUDINARY_URL + "barcode.png"} alt="barcode" />
            </span>
          </div>
          <div className="bodyBottom">
            <div className="pricewrapper">
              <span className="bottomlabel">{t("TICKET_PRICE")}</span>
              <span className="bottomValue">4 x ₹ 20.99</span>
            </div>
            <div className="pricewrapper">
              <span className="bottomlabel">{t("TICKET_PRICE")}</span>
              <span className="bottomValue">+ ₹ 20.00</span>
            </div>
            <div className="pricewrapper">
              <span className="bottomlabel">{t("GST_TEXT")}</span>
              <span className="bottomValue">+ ₹ 2.00</span>
            </div>
            <div className="pricewrapper">
              <span className="bottomlabel totalAmount">
                {t("TOTAL_AMOUNT")}
              </span>
              <span className="bottomValue totalAmount">₹ 105.96</span>
            </div>
            {/* AMOUNT_REFUNDED */}

            {/* <div className="pricewrapper">
              <span className="bottomlabel" >{t("SERVICE_CHARGE")}</span>
              <span className="bottomValue" >- ₹ 10.00</span>
            </div>
            <div className="pricewrapper">
              <span className="bottomlabel totalAmount" >{t("AMOUNT_REFUNDED")}</span>
              <span className="bottomValue totalAmount" >₹ 12.99</span>
            </div> */}
          </div>
        </div>
      </ConfirmModal>
    </>
  );
};

export default OrganiserDetailsComponent;
